import type { WordOfTheDayItem, KeywordSearchResult } from '@ilteducation/word-of-the-day-types';
import type { WordContext } from './store';

/** A user-picked word applies only for today, so we stamp it with today's date locally. */
export const keywordResultToWordItem = (result: KeywordSearchResult, todayIso: string): WordOfTheDayItem => ({
  ...result,
  date: todayIso,
});

/** Builds the description + CDN image url shown alongside the word. */
export const buildWordContext = (item: WordOfTheDayItem, cdnDomain: string | undefined): WordContext => ({
  description: item.description,
  imageUrl: item.imageId ? `${cdnDomain}/images/${item.imageId}/image.jpeg` : undefined,
});

/** Today's date as `YYYY-MM-DD` (local time), the format the word-of-the-day backend uses. */
export const todayIso = (): string => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
